import { render, staticRenderFns } from "./StudentExamQuiz.vue?vue&type=template&id=935fdaf0&scoped=true&"
import script from "./StudentExamQuiz.vue?vue&type=script&scoped=true&lang=js&"
export * from "./StudentExamQuiz.vue?vue&type=script&scoped=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935fdaf0",
  null
  
)

export default component.exports